import MojitoCore from 'mojito/core';
import MojitoServices from 'mojito/services';

import {AbstractFeature, allFeatures} from '#core/application/abstract-feature.js';

const reduxInstance = MojitoCore.Services.redux;

const betslipActions = MojitoServices.Betslip.actions;
const BetslipTypes = MojitoServices.Betslip.types;

class TracerFeature extends AbstractFeature {
    constructor(parent) {
        super(parent);
        this.handleBetPlacement = this.handleBetPlacement.bind(this);
    }

    get name() {
        return 'Tracer';
    }

    afterMojito() {
        reduxInstance.actionListener.startListening({
            actionCreator: betslipActions.placeBetslipSuccess,
            effect: this.handleBetPlacement,
        });

        return super.afterMojito();
    }

    handleBetPlacement({payload: {status, betslip = {}}}) {
        const errors = [];

        if (betslip.errors) {
            errors.push(...betslip.errors);
        }

        if (betslip.stakeGroups) {
            for (const [, stakeGroup] of Object.entries(betslip.stakeGroups)) {
                for (const [, stake] of Object.entries(stakeGroup.stakes)) {
                    if (stake.errors && stake.errors.length > 0) {
                        errors.push(...stake.errors);
                    }
                }
            }
        }

        if (errors.length > 0) {
            this.logger.error('placeBetslipSuccess', {
                status: status === BetslipTypes.PLACEMENT_STATUS.ACCEPTED ? 'success' : 'fail',
                error: errors,
            });
        }
    }
}

new TracerFeature(allFeatures);
